import React from 'react';
import { Alert, Button, Empty, Input } from 'antd';
import styles from '@pages/api-portal/styles.module.scss';
import { PageLoader } from '@pages/api-portal/page-loader';
import { EndpointGroupsList } from './endpoint-groups-list';
import { ApiEndpoint, ApiGroup } from '@pages/api-portal/types';

interface MainColumnProps {
    isLoading: boolean;
    catalogFetchFailed: boolean;
    onRetry: () => void;
    searchQuery: string;
    onSearchChange: (value: string) => void;
    totalCount: number;
    filteredCount: number;
    groupedEndpoints: Record<string, ApiEndpoint[]>;
    apiGroups: ApiGroup[];
    expandedGroups: string[];
    onToggleGroup: (groupId: string) => void;
}

/*
 * Search bar, result count, and the filtered/grouped endpoint list — or the
 * loading/error/empty states in place of it.
 */
export function MainColumn({
    isLoading,
    catalogFetchFailed,
    onRetry,
    searchQuery,
    onSearchChange,
    totalCount,
    filteredCount,
    groupedEndpoints,
    apiGroups,
    expandedGroups,
    onToggleGroup,
}: MainColumnProps) {
    return (
        <div style={{ flex: 1, padding: 16, overflowY: 'auto' }}>
            <Input.Search
                placeholder="Search APIs by name, description, path, or tag"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                style={{ marginBottom: 8, maxWidth: 480 }}
                allowClear
            />
            {!isLoading && !catalogFetchFailed && (
                <p className={styles.mutedText} style={{ marginBottom: 16 }}>
                    Showing {filteredCount} of {totalCount} endpoints
                </p>
            )}

            {isLoading ? (
                <PageLoader />
            ) : catalogFetchFailed ? (
                <Alert
                    type="error"
                    showIcon
                    message="Failed to load the API catalog"
                    description={<Button onClick={onRetry}>Retry</Button>}
                />
            ) : filteredCount === 0 ? (
                <Empty description="No APIs match your filters" />
            ) : (
                <EndpointGroupsList
                    groupedEndpoints={groupedEndpoints}
                    apiGroups={apiGroups}
                    expandedGroups={expandedGroups}
                    onToggleGroup={onToggleGroup}
                />
            )}
        </div>
    );
}
